import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bd0eea5a")

_pushScopeId("data-v-bd0eea5a")
const _hoisted_1 = { class: "lang-dialog-view-root" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "dialog-body" }
const _hoisted_4 = { class: "dialog-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["dialog-content", { desktop: _ctx.device.display !== 1 }],
      onClick: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["stop"]))
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", null, _toDisplayString(_ctx.iN('languagegialog.title')), 1),
        _createVNode("span", {
          class: "icon-close",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
        })
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("ul", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.langs, (i, index) => {
            return (_openBlock(), _createBlock("li", {
              key: `lang-${index}`,
              onClick: ($event: any) => (_ctx.selectedLang = i)
            }, [
              _createVNode("div", null, _toDisplayString(_ctx.iN(`lang.${i}`)), 1),
              _createVNode("div", {
                class: { active: i === _ctx.selectedLang }
              }, null, 2)
            ], 8, ["onClick"]))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          class: "confirm",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
        }, _toDisplayString(_ctx.iN('common.confirm')), 1),
        _createVNode("button", {
          class: "cancel",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
        }, _toDisplayString(_ctx.iN('common.cancel')), 1)
      ])
    ], 2)
  ]))
})